import { ImportStatsTable, Owner } from 'cargo-chief-commons';

export const automationRFPPageStateKey = 'automation-rfp-page';

export interface AutomationRFPState {
	activeUsersList: Array<Owner>;
	error: string;
	filters: any[];
	sort: any[];
	loading: boolean;
	rfpsList: ImportStatsTable[];
	total: number;
}

export const initialState: AutomationRFPState = {
	activeUsersList: [],
	error: null,
	filters: [],
	sort: [],
	loading: true,
	rfpsList: [],
	total: 0,
};
